import { atom } from "recoil";
import { uuidv4 } from '../lib/uuid';

// store websocket messages that have been 
// consumed by the app (triggered mutations or query invalidations)
export const wsMessagesBinState = atom({
    key: 'ws-message-bin',
    default: [],
})

// Add cache buster for reel videos
export const videoUuidState = atom({
    key: 'video-uuid',
    default: uuidv4(),
})